import { ConfigFile } from './types';

const KEY_PREFIX = 'knowledgeManagement.configFiles';

/** Builds the i18n keys of a config card; texts are translated at render time. */
const cardKeys = (key: string, specCount: number) => ({
  titleKey: `${KEY_PREFIX}.${key}.title`,
  descriptionKey: `${KEY_PREFIX}.${key}.description`,
  specKeys: Array.from({ length: specCount }, (_, index) => `${KEY_PREFIX}.${key}.specs.spec${index + 1}`),
});

export const CONFIG_FILES: ConfigFile[] = [
  {
    id: 'themes',
    ...cardKeys('themes', 4),
    filename: 'themes.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'source_types',
    ...cardKeys('sourceTypes', 4),
    filename: 'source_types.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'domain_entity_mapping',
    ...cardKeys('domainEntityMapping', 4),
    filename: 'domain_entity_mapping.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'entity_type_variations',
    ...cardKeys('entityTypeVariations', 4),
    filename: 'entity_type_variations.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'ontology_owl',
    ...cardKeys('ontologyOwl', 4),
    filename: 'ontology.owl',
    format: 'OWL/XML',
    accept: '.owl,.xml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'ontology_schema',
    ...cardKeys('ontologySchema', 4),
    filename: 'ontology_schema.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'thesaurus',
    ...cardKeys('thesaurus', 4),
    filename: 'thesaurus.json',
    format: 'JSON',
    accept: '.json',
    uploaded: false,
    loading: false,
  },
  {
    id: 'system_messages',
    ...cardKeys('systemMessages', 4),
    filename: 'system_messages.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'prompts',
    ...cardKeys('prompts', 4),
    filename: 'prompts.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'rag_prompts',
    ...cardKeys('ragPrompts', 4),
    filename: 'rag_prompts.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'entity_extraction_prompts',
    ...cardKeys('entityExtractionPrompts', 4),
    filename: 'entity_extraction_prompts.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'script_prompts',
    ...cardKeys('scriptPrompts', 4),
    filename: 'script_prompts.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
  {
    id: 'reference_texts',
    ...cardKeys('referenceTexts', 4),
    filename: 'reference_texts.yml',
    format: 'YAML',
    accept: '.yml,.yaml',
    uploaded: false,
    loading: false,
  },
];
